import React, { useState, useEffect, useCallback } from 'react';
import { Row, Col, Select, Button, Form } from 'antd';

const SelectType = ({ question, onEdit, onChange, isMultiple = false }) => {
  const [selectedOption, setSelectedOption] = useState(isMultiple ? [] : undefined);
  const [form] = Form.useForm();

  const setFieldValue = useCallback(() => {
    if (isMultiple) {
      setSelectedOption([]);
      if (question.selectedAnswer) {
        const answerArray = Array.isArray(question.selectedAnswer)
          ? question.selectedAnswer
          : question.selectedAnswer.split(',').map(item => item.trim()).filter(Boolean);
        form.setFieldsValue({ option: answerArray });
        setSelectedOption(answerArray);
      }
    } else {
      setSelectedOption();
      if (question.selectedAnswer) {
        form.setFieldsValue({ option: question.selectedAnswer });
        setSelectedOption(question.selectedAnswer.toString());
      }
    }
  }, [question.selectedAnswer, isMultiple, form]);

  const onFinish = values => {
    let valueToSave;
    if (isMultiple) {
      valueToSave = Array.isArray(values.option) ? values.option.join(', ') : values.option;
    } else {
      valueToSave = values.option;
    }
    onChange(question.testId, question.groupId, question.questionId, valueToSave);
    form.resetFields();
  };

  const handleSelect = (value) => {
    setSelectedOption(value);
    onEdit(question.questionId, value);
  };

  useEffect(() => {
    form.resetFields();
    setFieldValue();
  }, [setFieldValue, form]);

  return (
    <Row justify="center">
      <Form
        onFinish={onFinish}
        form={form}
        initialValues={{ option: isMultiple ? [] : question.selectedAnswer }}
        style={{ width: '100%' }}
      >
        <Col md={24}>
          <Row justify="center">
            <Col md={24} className="options-wrapper p-40 mt-40 mb-80">
              <Row justify="center">
                <Col md={24}>
                  <h2 className="text-center mt-10 mb-50" dangerouslySetInnerHTML={{ __html: question.questionTitle && question.questionTitle }} />
                </Col>
                <Col md={10}>
                  <Form.Item
                    name="option"
                    className="mb-0"
                  >
                    <Select
                      mode={isMultiple ? "multiple" : undefined}
                      style={{ width: '100%' }}
                      placeholder={question.questionTitle && question.questionTitle}
                      size="large"
                      onChange={handleSelect}
                      value={selectedOption}
                      maxTagCount={isMultiple ? "responsive" : undefined}
                      allowClear={isMultiple}
                    >
                      {
                        question && question.questionOptions && question.questionOptions.map((option, index) =>
                          <Select.Option
                            key={index}
                            value={option.text.toString()}
                          >
                            {option.text}
                          </Select.Option>
                        )
                      }
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          </Row>
          {
            question && !question.isChecking &&
            <Row justify="end" className="mb-40">
              <Col md={6}>
                <Button
                  disabled={isMultiple ? !selectedOption || selectedOption.length === 0 : !selectedOption}
                  className={isMultiple ? (!selectedOption || selectedOption.length === 0 ? 'button-disabled' : '') : (!selectedOption ? 'button-disabled' : '')}
                  type="primary"
                  size="large"
                  htmlType="submit"
                  block
                >
                  Confirmar cambio
                </Button>
              </Col>
            </Row>
          }
        </Col>
      </Form>
    </Row>
  );
};

export default SelectType;
